import axios from "./axiosConfig";
import { apis } from './params';

export function getReviewsService(_param: any) {
    return axios({
        "method": "Get",
        "url": apis.GET_REVIEWS + _param
    })
}

export function updateReviewService(_payload: any) {
    return axios({
        "method": "POST",
        "url": apis.UPDATE_REVIEW,
        "data": _payload
    })
}

export function reviewReplyService(_payload: any) {
    return axios({
        "method": "POST",
        "url": apis.REVIEW_REPLY,
        "data": _payload
    })
}

export function uploadReviewsFileService(_data: any) {
    return axios({
        "method": "Post",
        "url": apis.UPLOAD_REVIEWS + _data.param,
        "data": _data.data,
        "headers": {
            "Content-Type": "multipart/form-data"
        }
    })
}

export function downloadReviews(param: any) {
    return axios({
        method: 'GET',
        url: apis.DOWNlOAD_REVIEWS + param
    })
}

export function generatePresignedUrlService(params: { fileType: string; fileName: string; contentType: string; contentLength: number }) {
    return axios({
        method: 'POST',
        url: apis.GENERATE_PRESIGNED_URL,
        data: params
    })
}